import { IconTick, InfoIcon, InputMessage, theme, typographyRem } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { ProviderContext } from '../../Provider'
const { paragraphBody: ParagraphBody, labelMedium: LabelMedium, labelSmall: LabelSmall } = typographyRem

const BenefitsStyle = styled.div`
  .helper-banner {
    &.hide {
      display: none;
    }
  }
  .info-wrapper {
    position: absolute;
    right: 0;
    width: 100%;
    div[type='info'] {
      left: auto;
      right: -20px;
      bottom: 15px;
      z-index: 9;
      &:before {
        left: auto !important;
        right: 20px !important;
      }
    }
  }
`

export const BenefitsWrapper = ({ heading, items, isElectric }) => {
  const { state, handleShowInfo } = useContext(ProviderContext)

  return (
    <BenefitsStyle className="container">
      <LabelMedium className="heading">{heading}</LabelMedium>
      <ul>
        {items.map((item, index) => {
          if ((item.electricOnly && isElectric) || !item.electricOnly) {
            return (
              <div key={`${item.info}_${index}`}>
                <li>
                  <IconTick />
                  <ParagraphBody className="item">{item.description}</ParagraphBody>
                  {item.electricOnly && isElectric && (
                    <LabelSmall className="electric-badge desktop">Electric friendly</LabelSmall>
                  )}
                  <div
                    className="info-wrapper"
                    onClick={() => handleShowInfo(`${heading.replace(/ /g, '_')}_info_${index}`)}
                  >
                    {item.info &&
                      state.showHelper &&
                      state.helperName === `${heading.replace(/ /g, '_')}_info_${index}` && (
                        <InputMessage
                          id={`${heading.replace(/ /g, '_')}_info_${index}`}
                          position="top"
                          type="info"
                          message={item.info}
                          className={`helper-banner`}
                        />
                      )}
                    <InfoIcon fill={theme.primaryColours.cyan.superDarkCyan} />
                  </div>
                </li>
                {item.electricOnly && isElectric && (
                  <LabelSmall className="electric-badge mobile">Electric friendly</LabelSmall>
                )}
              </div>
            )
          } else return null
        })}
      </ul>
    </BenefitsStyle>
  )
}
